/* global define */

window._define('widgets/messageList', ['jquery', 'app/core', 'widgets/baseWidget'], function ($, core, BaseWidget) { 'use strict';

    // widget definition
    $.widget('OC.messageList', BaseWidget, {
        options: {

        },

        _create: function () {
            this._super();

            this.elements.$toggleAll = $('.js-list-msg-toggleall', this.element);
            this.elements.$selectedMsg = $('.js-list-msg-selectedtext', this.element);
            this.elements.$selectAll = $('.js-list-msg-selectalltext', this.element);

            this._attachEvents();
        },

        _attachEvents: function () {
            var self = this;

            $(this.element)
                .on('click', '.js-list-msg-selectalltext', function () {
                    self.toggleMessages(true);
                })
                .on('change', '.js-list-msg-toggleall', function () {
                    self.toggleMessages($(this).is(':checked'));
                })
                .on('change', '.js-list-msg-toggle', function () {
                    var $check = $(this);
                    self.toggleMessages($check.is(':checked'), $check.parents('tr'));
                });
        },

        _updateDisplay: function () {
            var amount = this.getSelectedAmount(),
                hasSelected = (amount > 0);

            this.element.toggleClass('list-msg--selected', hasSelected);
            this._updateSelectedText();

            this._trigger('select', null, { amount: amount });
        },

        _updateSelectedText: function () {
            var amount = this.getSelectedAmount(),
                total = this.getItemAmount(),

                // TODO: use i18n
                text = (amount === 1) ? '<strong>1</strong> message sélectionné.' : '<strong>' + amount + '</strong> messages sélectionnés.';

            this.elements.$selectedMsg.html(text);
            this.elements.$selectAll
                .html(core.string.format(this.elements.$selectAll.html(), total))
                .toggle(amount < total);
        },

        toggleMessages: function (state, $elements) {
            if (!$elements) {
                $elements = $('tbody tr', this.element);
                if (state) {
                    this.elements.$toggleAll.prop('checked', true);
                }
            } else {
                $elements = $($elements);
            }

            $elements
                .toggleClass('list-msg__item--selected', state)
                .find('.js-list-msg-toggle')
                .prop('checked', state);

            this._updateDisplay();
        },

        getSelectedAmount: function () {
            return $('.js-list-msg-toggle:checked', this.element).length;
        },

        getItemAmount: function () {
            return $('tbody tr', this.element).length;
        }
    });

    return $.OC.messageList;
});
